import { RefObject } from "react";
import { notify } from "./notice";

export const startVideoStream = async (videoRef: RefObject<HTMLVideoElement>): Promise<MediaStream | null> => {
  const videoElement = videoRef.current;
  if (!videoElement) return null;

  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        width: { ideal: 3840 }, // Suggest 4K resolution (or higher)
        height: { ideal: 2160 },
        facingMode: "environment",
      },
    });

    //console.log("Camera stream started:", stream);
    videoElement.srcObject = stream;
    await videoElement.play();
    return stream;
  } catch (error: any) {
    console.error("Error accessing camera:", error);
    if (error.name !== "AbortError") {
      // ブラウザのエラー文は英語なので、よくある原因は日本語で伝える
      const reasons: Record<string, string> = {
        NotAllowedError: "カメラの使用が許可されていません。ブラウザの設定でカメラを許可してください。",
        NotFoundError: "カメラが見つかりません。",
        NotReadableError: "カメラをほかのアプリが使っている可能性があります。",
      };
      notify("カメラにアクセスできませんでした。\n" + (reasons[error.name] ?? error.message), "エラー");
    }
    return null;
  }
};
